import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  withStyles,
  makeStyles,
} from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import tableStyle from "../../CustomerSuccess/styles/tableStyle";

import {
  countOrACVFormatter,
  dateFormatterMonthInWords,
  StyledTableRow,
  _isNaN,
  customDateFormatter,
  getUniqueValues,
} from "../../util/customFunctions";
import HoverableIcon from "../../components/Buttons/HoverableIcon ";
import * as FileSaver from "file-saver";
import CopyTablesObject from "../../components/xlsx-export/CopyTablesObject";
import DashboardInsights from "./DashboardInsights";
import { getSegmentHighlight, getPrimaryHighlight } from "./demandHighlightUtils";

const useStickyFirstCol = makeStyles({
  root: {
    // Sticky first column — body cells
    '& tbody td:first-child': {
      position: 'sticky',
      left: 0,
      zIndex: 3,
      backgroundColor: 'white',
    },
    // Sticky first column — header cell (MUI renders TableCell in TableHead as <th>)
    '& thead th:first-child': {
      position: 'sticky',
      left: 0,
      zIndex: 7,
    },
  },
});

// Custom styled tooltip
const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "rgb(255,255,255,0.9)",
    color: "black",
    fontFamily: "roboto",
    fontSize: theme.typography.pxToRem(14),
    borderRadius: "1rem",
    padding: "12px 16px",
    boxShadow: "0 0.2rem 0.4rem rgba(0,0,0,0.2)",
    marginTop: "0.4rem",
    maxWidth: 400,
  },
}))(Tooltip);

// Helper function to render superscripts with larger font
const renderSuperscripts = (superscripts, clr) => {
  if (!superscripts || superscripts.length === 0) return null;

  return (
    <sup style={{ fontSize: '1.1em', fontWeight: 'bold', color: clr, marginLeft: '4px' }}>
      {superscripts.join(',')}
    </sup>
  );
};


export default function DemandGenTable(props) {
  const classes = tableStyle();
  const stickyClasses = useStickyFirstCol();
  const tableRef = React.createRef();
  const tableContainerRef = useRef();

  const [parentWidth, setparentWidth] = useState();

  const industries = props.totalColumnData
    .sort((a, b) => b.acvPursued - a.acvPursued)
    .map((s) => s[props.primary]);
  let segments =
    props.toggleValue === "AcvSort"
      ? props.acv_acct_size_segmets
      : props.logic_acct_size_segmets;

  console.log(props.insights, 'gsafddafdyufygayu');

  // Helper function to check if a row should be greyed out (superscript 'a')
  const shouldGreyOutRow = (industry) => {
    const columnData = props.totalColumnData.filter(
      (i) => i[props.primary] === industry
    );
    if (columnData.length === 0) return false;
    const superscripts = columnData[0].superscripts || [];
    return superscripts.includes('a');
  };

  // Helper function to check if a column should be greyed out (superscript 'b')
  const shouldGreyOutColumn = (segment, industry) => {
    const rowData = props.tableData.filter(
      (item) =>
        item[props.primary] === industry &&
        item[props.secondary] === segment
    );
    if (rowData.length === 0) return false;
    const superscripts = rowData[0].superscripts || [];
    return superscripts.includes('b');
  };

  // Helper function to check if won cell should be greyed out (superscript 'c')
  const shouldGreyOutWonCell = (segment, industry) => {
    const rowData = props.tableData.filter(
      (item) =>
        item[props.primary] === industry &&
        item[props.secondary] === segment
    );
    if (rowData.length === 0) return false;
    const superscripts = rowData[0].superscripts || [];
    return superscripts.includes('c');
  };

  // NEW: Helper function to check if a column in Grand Total should be greyed out
  const shouldGreyOutGrandTotalColumn = (segment) => {
    const rowData = props.wonRowData.filter(
      (item) => item[props.secondary] === segment
    );
    if (rowData.length === 0) return false;
    const superscripts = rowData[0].superscripts || [];
    return superscripts.includes('a') || superscripts.includes('b');
  };

  // NEW: Helper function to check if won cell in Grand Total should be greyed out
  const shouldGreyOutGrandTotalWonCell = (segment) => {
    const rowData = props.wonRowData.filter(
      (item) => item[props.secondary] === segment
    );
    if (rowData.length === 0) return false;
    const superscripts = rowData[0].superscripts || [];
    return superscripts.includes('c');
  };

  useEffect(() => {
    const parentWidth = tableContainerRef.current.getBoundingClientRect().width;
    setparentWidth(parentWidth);
  }, [parentWidth]);

  return (
    <>
      {parentWidth !== undefined ? (
        <div
          style={{
            display: "flex",
            justifyContent: "right",
            marginBottom: "0.2rem",
            width: `${parentWidth}px`,
          }}
        >
          <CopyTablesObject tableRef={tableRef} />
        </div>
      ) : null}
      <TableContainer
        style={{
          margin: "2rem",
          width: "100%",
          maxHeight: "86vh",
          overflowX: "auto",
          borderTop: "0.5px solid lightgrey",
        }}
        ref={tableContainerRef}
      >
        <Table
          ref={tableRef}
          size="small"
          aria-label="html table"
          style={{ tableLayout: "auto" }}
          className={stickyClasses.root}
          data-test={props.dataTest}
        >
          <TableHead
            style={{
              position: "sticky",
              top: -1,
              zIndex: 5,
              outline: "lightgrey solid 0.9px",
              outlineOffset: "-1.5px",
            }}
          >
            <TableRow
              style={{
                fontWeight: 600,
                background: "#4472c4",
                color: "white",
                position: "sticky",
              }}
            >
              <TableCell
                className={classes.colHeader}
                style={{ background: "#4471C4", color: "white", minWidth: 220 }}
                align="center"
              >
                {props.primaryLabel} <span>&#8595;</span> /{" "}
                {props.secondaryLabel} <span>&#8594;</span>
              </TableCell>
              {segments.map((segment) => (
                <TableCell
                  key={segment}
                  style={{
                    background: "#4471C4",
                    color: "white",
                    width: 60,
                    whiteSpace: "normal",
                  }}
                  align="center"
                  className={classes.colHeader}
                >
                  {segment}
                </TableCell>
              ))}
              <TableCell
                style={{
                  background: "#4471C4",
                  color: "white",
                  width: 60,
                  maxWidth: 60,
                  whiteSpace: "normal",
                }}
                align="center"
                className={classes.colHeader}
              >
                {"Grand Total"}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {industries.map((industry, idx) => {
              const columnData = props.totalColumnData.filter(
                (i) => i[props.primary] === industry
              );
              let totalpursued =
                columnData.length !== 0 ? columnData[0].acvPursued : "";
              let totalpursuedCount =
                columnData.length !== 0 ? columnData[0].countPursued : "";
              let totalwon = columnData.length !== 0 ? columnData[0].acv : "";
              let totalAvgCycleTime =
                columnData.length !== 0 ? columnData[0].avgCycleTime : "";
              let totalMedianCycleTime =
                columnData.length !== 0 ? columnData[0].medianCycleTime : "";
              let totalCount =
                columnData.length !== 0 ? columnData[0].count : "";
              let totallost =
                columnData.length !== 0 ? columnData[0].lostAcv : "";
              let totallostCount =
                columnData.length !== 0 ? columnData[0].lostCount : "";
              let totalwinRate =
                columnData.length !== 0 ? columnData[0].winRatePercentage : "";
              let totalpipelineAcv =
                columnData.length !== 0 ? columnData[0].pipelineAcv : "";
              
              // Get superscripts for this primary dimension (industry)
              const primarySuperscripts = columnData.length !== 0 ? columnData[0].superscripts : [];
              const rowGreyedOut = shouldGreyOutRow(industry);
              const rowTooltipText = props.primaryDimensionAnnotations?.[industry]?.tooltips?.a || '';

              return (
                <React.Fragment key={idx}>
                  {/* Pursued Row */}
                  <StyledTableRow>
                    <HtmlTooltip title={rowTooltipText || ''} disableHoverListener={!rowTooltipText}>
                      <TableCell
                        style={{ 
                          background: rowGreyedOut ? "#e0e0e0" : "#5b9bd5", 
                          color: rowGreyedOut ? "black" : "white",
                          opacity: rowGreyedOut ? 0.7 : 1
                        }}
                        align="left"
                        className={classes.colHeader}
                      >
                        {industry} ({`${props.Value_Label}`} Pursued)
                        {renderSuperscripts(
                          primarySuperscripts.filter(s => s === 'a'),
                          rowGreyedOut ? "black" : "white"
                        )}
                      </TableCell>
                    </HtmlTooltip>
                    {segments.map((segment) => {
                      let rowData = props.tableData.filter(
                        (item) =>
                          item[props.primary] === industry &&
                          item[props.secondary] === segment
                      );
                      let pursued =
                        rowData.length !== 0 ? rowData[0].acvPursued : "";
                      let pursuedCount =
                        rowData.length !== 0 ? rowData[0].countPursued : "";
                      let superscripts = rowData.length !== 0 ? rowData[0].superscripts : [];
                      
                      const acvSegHighlight = getSegmentHighlight(
                        props.highlightData, props.primary, industry,
                        'maxAcvPursuedSegments', 'minACVPursuedSegments', segment
                      );

                      const columnGreyedOut = shouldGreyOutColumn(segment, industry);

                      let baseStyle;
                      if (acvSegHighlight) {
                        baseStyle = { ...acvSegHighlight, cursor: 'pointer' };
                      } else {
                        baseStyle = { background: "#5b9bd5", color: "white", cursor: 'pointer' };
                      }

                      const cellStyle = rowGreyedOut 
                        ? { ...baseStyle, backgroundColor: '#e0e0e0', color: 'black', opacity: 0.7 }
                        : columnGreyedOut
                        ? { ...baseStyle, backgroundColor: '#e0e0e0', color: 'black', opacity: 0.7 }
                        : baseStyle;

                      // When row is greyed out (superscript 'a'), suppress cell-level superscripts
                      const cellSuperscripts = rowGreyedOut ? [] : superscripts.filter(s => s === 'b');
                      const tooltipText = rowGreyedOut
                        ? rowTooltipText
                        : (props.cellAnnotations?.[`${industry}|||${segment}`]?.tooltips?.b || '');

                      return (
                        <HtmlTooltip key={segment} title={tooltipText || ''} disableHoverListener={!tooltipText}>
                          <TableCell
                            style={cellStyle}
                            onClick={() =>
                              props.handleChangeLocation(
                                "drilldownOnGraph",
                                { industry: [industry], segment: [segment] },
                                "Pursued",
                                props.type
                              )
                            }
                            align="right"
                            className={classes.colHeader}
                          >
                            <span align="right">
                              {![null, undefined, "", 0, "0"].includes(pursued)
                                ? countOrACVFormatter(pursued, true)
                                : "-"}
                            </span>
                            <span
                              align="right"
                              style={{ marginLeft: "1rem" }}
                            >{`(${
                              ![null, undefined, "", 0, "0"].includes(pursuedCount)
                                ? countOrACVFormatter(pursuedCount, false)
                                : "-"
                            })`}</span>
                            {renderSuperscripts(
                              cellSuperscripts,
                              cellStyle.color
                            )}
                          </TableCell>
                        </HtmlTooltip>
                      );
                    })}
                    {(() => {
                      const acvColHighlight = getPrimaryHighlight(
                        props.primaryHighlights, 'maxACVPursuedPrimaries', 'minACVPursuedPrimaries', industry
                      );
                      const acvColStyle = rowGreyedOut
                        ? { backgroundColor: '#e0e0e0', color: 'black', cursor: 'pointer', opacity: 0.7 }
                        : acvColHighlight
                        ? { ...acvColHighlight, cursor: 'pointer' }
                        : { background: "#5b9bd5", color: "white", cursor: 'pointer' };
                      return (
                        <HtmlTooltip title={rowTooltipText || ''} disableHoverListener={!rowTooltipText}>
                          <TableCell
                            style={acvColStyle}
                            align="right"
                            className={classes.colHeader}
                            onClick={() =>
                              props.handleChangeLocation(
                                "drilldownOnGraph",
                                { industry: [industry], segment: segments },
                                "Pursued",
                                props.type
                              )
                            }
                          >
                            <span>
                              {![null, undefined, "", 0, "0"].includes(totalpursued)
                                ? countOrACVFormatter(totalpursued, true)
                                : "-"}
                            </span>
                            <span align="right" style={{ marginLeft: "1rem" }}>{`(${
                              ![null, undefined, "", 0, "0"].includes(totalpursuedCount)
                                ? countOrACVFormatter(totalpursuedCount, false)
                                : "-"
                            })`}</span>
                          </TableCell>
                        </HtmlTooltip>
                      );
                    })()}
                  </StyledTableRow>

                  {/* Lost or Disqualified Row */}
                  <StyledTableRow>
                    <HtmlTooltip title={rowTooltipText || ''} disableHoverListener={!rowTooltipText}>
                      <TableCell
                        style={rowGreyedOut ? { backgroundColor: '#e0e0e0', color: 'black', opacity: 0.7 } : {}}
                        align="left"
                        className={classes.colHeader}
                      >{`Lost or Disqualified (${props.lostStageFrom} or later)`}</TableCell>
                    </HtmlTooltip>
                    {segments.map((segment) => {
                      let rowData = props.tableData.filter(
                        (item) =>
                          item[props.primary] === industry &&
                          item[props.secondary] === segment
                      );
                      let lost = rowData.length !== 0 ? rowData[0].lostAcv : "";
                      let lostCount =
                        rowData.length !== 0 ? rowData[0].lostCount : "";
                      let superscripts = rowData.length !== 0 ? rowData[0].superscripts : [];
                      
                      const columnGreyedOut = shouldGreyOutColumn(segment, industry);
                      const cellStyle = rowGreyedOut || columnGreyedOut
                        ? { backgroundColor: '#e0e0e0', color: 'black', opacity: 0.7, cursor: "pointer" }
                        : { cursor: "pointer" };

                      const cellSuperscriptsLost = rowGreyedOut ? [] : superscripts.filter(s => s === 'b');
                      const tooltipText = rowGreyedOut
                        ? rowTooltipText
                        : (props.cellAnnotations?.[`${industry}|||${segment}`]?.tooltips?.b || '');

                      return (
                        <HtmlTooltip key={segment} title={tooltipText || ''} disableHoverListener={!tooltipText}>
                          <TableCell
                            style={cellStyle}
                            onClick={() =>
                              props.handleChangeLocation(
                                "drilldownOnGraph",
                                { industry: [industry], segment: [segment] },
                                "Lost",
                                props.type
                              )
                            }
                            align="right"
                            className={classes.colHeader}
                          >
                            <span>
                              {![null, undefined, "", 0, "0"].includes(lost)
                                ? countOrACVFormatter(lost, true)
                                : "-"}
                            </span>
                            <span
                              align="right"
                              style={{ marginLeft: "1rem" }}
                            >{`(${
                              ![null, undefined, "", 0, "0"].includes(lostCount)
                                ? countOrACVFormatter(lostCount, false)
                                : "-"
                            })`}</span>
                          </TableCell>
                        </HtmlTooltip>
                      );
                    })}
                    <HtmlTooltip title={rowTooltipText || ''} disableHoverListener={!rowTooltipText}>
                      <TableCell
                        onClick={() =>
                          props.handleChangeLocation(
                            "drilldownOnGraph",
                            { industry: [industry], segment: segments },
                            "Lost",
                            props.type
                          )
                        }
                        style={rowGreyedOut 
                          ? { backgroundColor: '#e0e0e0', color: 'black', opacity: 0.7, cursor: "pointer" }
                          : { cursor: "pointer" }
                        }
                        align="right"
                        className={classes.colHeader}
                      >
                        <span>
                          {![null, undefined, "", 0, "0"].includes(totallost)
                            ? countOrACVFormatter(totallost, true)
                            : "-"}
                        </span>
                        <span align="right" style={{ marginLeft: "1rem" }}>{`(${
                          ![null, undefined, "", 0, "0"].includes(totallostCount)
                            ? countOrACVFormatter(totallostCount, false)
                            : "-"
                        })`}</span>
                      </TableCell>
                    </HtmlTooltip>
                  </StyledTableRow>

                  {/* Won Row */}
                  <StyledTableRow>
                    <HtmlTooltip title={rowTooltipText || ''} disableHoverListener={!rowTooltipText}>
                      <TableCell 
                        style={rowGreyedOut ? { backgroundColor: '#e0e0e0', color: 'black', opacity: 0.7 } : {}}
                        align="left" 
                        className={classes.colHeader}
                      >
                        Won
                      </TableCell>
                    </HtmlTooltip>
                    {segments.map((segment) => {
                      let rowData = props.tableData.filter(
                        (item) =>
                          item[props.primary] === industry &&
                          item[props.secondary] === segment
                      );
                      let won = rowData.length !== 0 ? rowData[0].acv : "";
                      let count = rowData.length !== 0 ? rowData[0].count : "";
                      let superscripts = rowData.length !== 0 ? rowData[0].superscripts : [];
                      
                      const columnGreyedOut = shouldGreyOutColumn(segment, industry);
                      const wonCellGreyedOut = shouldGreyOutWonCell(segment, industry);

                      // Check if this is the min win rate cell (orange) - don't grey it out even with 'c'
                      const isMinWinRateCell = props.highlightData ? props.highlightData.filter(
                        (i) => i[props.primary] === industry && Array.isArray(i.minWinRateSegments) && i.minWinRateSegments.includes(segment)
                      ).length >= 1 : false;

                      const cellStyle = rowGreyedOut || columnGreyedOut
                        ? { backgroundColor: '#e0e0e0', color: 'black', opacity: 0.7, cursor: "pointer" }
                        : (wonCellGreyedOut && !isMinWinRateCell)
                        ? { backgroundColor: '#e0e0e0', color: 'black', opacity: 0.7, cursor: "pointer" }
                        : { cursor: "pointer" };

                      // When row greyed out, suppress cell superscripts; otherwise show 'c' on Won cell
                      const cellSuperscriptsWon = rowGreyedOut ? [] : superscripts.filter(s => s === 'c');
                      const tooltipText = rowGreyedOut
                        ? rowTooltipText
                        : (props.cellAnnotations?.[`${industry}|||${segment}`]?.tooltips?.c || '');

                      return (
                        <HtmlTooltip key={segment} title={tooltipText || ''} disableHoverListener={!tooltipText}>
                          <TableCell
                            style={cellStyle}
                            onClick={() =>
                              props.handleChangeLocation(
                                "drilldownOnGraph",
                                { industry: [industry], segment: [segment] },
                                "Won",
                                props.type
                              )
                            }
                            align="right"
                            className={classes.colHeader}
                          >
                            <span>
                              {![null, undefined, "", 0, "0"].includes(won)
                                ? countOrACVFormatter(won, true)
                                : "-"}
                            </span>
                            <span
                              align="right"
                              style={{ marginLeft: "1rem" }}
                            >{`(${
                              ![null, undefined, "", 0, "0"].includes(count)
                                ? countOrACVFormatter(count, false)
                                : "-"
                            })`}</span>
                            {renderSuperscripts(cellSuperscriptsWon, cellStyle.color || 'black')}
                          </TableCell>
                        </HtmlTooltip>
                      );
                    })}
                    {(() => {
                      // 'c' superscript on Total column Won cell when primary fails opps threshold
                      const wonColSuperscripts = !rowGreyedOut && primarySuperscripts.includes('c') ? ['c'] : [];
                      let wonColStyle;
                      if (rowGreyedOut || primarySuperscripts.includes('c')) {
                        wonColStyle = { backgroundColor: '#e0e0e0', color: 'black', opacity: 0.7, cursor: 'pointer' };
                      } else {
                        wonColStyle = { cursor: 'pointer' };
                      }
                      const wonColTooltip = wonColSuperscripts.length > 0
                        ? (props.primaryDimensionAnnotations?.[industry]?.tooltips?.c || '')
                        : (rowTooltipText || '');
                      return (
                        <HtmlTooltip title={wonColTooltip || ''} disableHoverListener={!wonColTooltip}>
                          <TableCell
                            onClick={() =>
                              props.handleChangeLocation(
                                "drilldownOnGraph",
                                { industry: [industry], segment: segments },
                                "Won",
                                props.type
                              )
                            }
                            style={wonColStyle}
                            align="right"
                            className={classes.colHeader}
                          >
                            <span>
                              {![null, undefined, "", 0, "0"].includes(totalwon)
                                ? countOrACVFormatter(totalwon, true)
                                : "-"}
                            </span>
                            <span align="right" style={{ marginLeft: "1rem" }}>{`(${
                              ![null, undefined, "", 0, "0"].includes(totalCount)
                                ? countOrACVFormatter(totalCount, false)
                                : "-"
                            })`}</span>
                            {renderSuperscripts(wonColSuperscripts, wonColStyle.color || 'black')}
                          </TableCell>
                        </HtmlTooltip>
                      );
                    })()}
                  </StyledTableRow>

                  {/* Won % of Total Row */}
                  <StyledTableRow>
                    <HtmlTooltip title={rowTooltipText || ''} disableHoverListener={!rowTooltipText}>
                      <TableCell 
                        style={rowGreyedOut ? { backgroundColor: '#e0e0e0', color: 'black', opacity: 0.7 } : {}}
                        align="left" 
                        className={classes.colHeader}
                      >
                        Won % of Total
                      </TableCell>
                    </HtmlTooltip>
                    {segments.map((segment) => {
                      let rowData = props.tableData.filter(
                        (item) =>
                          item[props.primary] === industry &&
                          item[props.secondary] === segment
                      );
                      let wonPercentage =
                        rowData.length !== 0
                          ? rowData[0].wonTotalPercentage
                          : "";
                      let superscripts = rowData.length !== 0 ? rowData[0].superscripts : [];
                      
                      const columnGreyedOut = shouldGreyOutColumn(segment, industry);
                      const cellStyle = rowGreyedOut || columnGreyedOut
                        ? { backgroundColor: '#e0e0e0', color: 'black', opacity: 0.7 }
                        : {};

                      const cellSuperscriptsWonPct = rowGreyedOut ? [] : superscripts.filter(s => s === 'b');
                      const tooltipText = rowGreyedOut
                        ? rowTooltipText
                        : (props.cellAnnotations?.[`${industry}|||${segment}`]?.tooltips?.b || '');

                      return (
                        <HtmlTooltip key={segment} title={tooltipText || ''} disableHoverListener={!tooltipText}>
                          <TableCell
                            style={cellStyle}
                            align="right"
                            className={classes.colHeader}
                          >
                            {" "}
                            {![null, undefined, ""].includes(wonPercentage)
                              ? `${Math.round(wonPercentage * 100)}%`
                              : "-"}
                          </TableCell>
                        </HtmlTooltip>
                      );
                    })}
                    <HtmlTooltip title={rowTooltipText || ''} disableHoverListener={!rowTooltipText}>
                      <TableCell
                        style={rowGreyedOut ? { backgroundColor: '#e0e0e0', color: 'black', opacity: 0.7 } : {}}
                        align="right"
                        className={classes.colHeader}
                      >
                        100%
                      </TableCell>
                    </HtmlTooltip>
                  </StyledTableRow>

                  {/* Avg / Median Cycle Time Row */}
                  <StyledTableRow>
                    <HtmlTooltip title={rowTooltipText || ''} disableHoverListener={!rowTooltipText}>
                      <TableCell
                        style={rowGreyedOut ? { backgroundColor: '#e0e0e0', color: 'black', opacity: 0.7 } : {}}
                        align="left"
                        className={classes.colHeader}
                      >{`Avg. / Median Cycle Time  (${props.lostStageFrom} to Won)`}</TableCell>
                    </HtmlTooltip>
                    {segments.map((segment) => {
                      let rowData = props.tableData.filter(
                        (item) =>
                          item[props.primary] === industry &&
                          item[props.secondary] === segment
                      );
                      let averageCycleTime =
                        rowData.length !== 0 ? rowData[0].avgCycleTime : "";
                      let medianCycleTime =
                        rowData.length !== 0 ? rowData[0].medianCycleTime : "";
                      let superscripts = rowData.length !== 0 ? rowData[0].superscripts : [];

                      const columnGreyedOut = shouldGreyOutColumn(segment, industry);
                      const cellStyle = rowGreyedOut || columnGreyedOut
                        ? { backgroundColor: '#e0e0e0', color: 'black', opacity: 0.7 }
                        : {};

                      const cellSuperscriptsCycle = rowGreyedOut ? [] : superscripts.filter(s => s === 'b');
                      const tooltipText = rowGreyedOut
                        ? rowTooltipText
                        : (props.cellAnnotations?.[`${industry}|||${segment}`]?.tooltips?.b || '');

                      return (
                        <HtmlTooltip key={segment} title={tooltipText || ''} disableHoverListener={!tooltipText}>
                          <TableCell 
                            style={cellStyle}
                            align="right" 
                            className={classes.colHeader}
                          >
                            <span>
                              {![null, undefined, "", 0, "0"].includes(
                                averageCycleTime
                              )
                                ? countOrACVFormatter(averageCycleTime, false)
                                : "-"}
                            </span>
                            <span style={{ margin: "0.25rem" }}>/</span>
                            <span>{`${
                              ![null, undefined, "", 0, "0"].includes(
                                medianCycleTime
                              )
                                ? countOrACVFormatter(medianCycleTime, false)
                                : "-"
                            }`}</span>
                          </TableCell>
                        </HtmlTooltip>
                      );
                    })}
                    <HtmlTooltip title={rowTooltipText || ''} disableHoverListener={!rowTooltipText}>
                      <TableCell 
                        style={rowGreyedOut ? { backgroundColor: '#e0e0e0', color: 'black', opacity: 0.7 } : {}}
                        align="right" 
                        className={classes.colHeader}
                      >
                        <span>
                          {![null, undefined, "", 0, "0"].includes(
                            totalAvgCycleTime
                          )
                            ? countOrACVFormatter(totalAvgCycleTime, false)
                            : "-"}
                        </span>
                        <span style={{ margin: "0.25rem" }}>/</span>
                        <span>{`${
                          ![null, undefined, "", 0, "0"].includes(
                            totalMedianCycleTime
                          )
                            ? countOrACVFormatter(totalMedianCycleTime, false)
                            : "-"
                        }`}</span>
                      </TableCell>
                    </HtmlTooltip>
                  </StyledTableRow>

                  {/* Win Rate Row */}
                  <StyledTableRow>
                    <HtmlTooltip title={rowGreyedOut ? (rowTooltipText || '') : (props.primaryDimensionAnnotations?.[industry]?.tooltips?.c || rowTooltipText || '')} disableHoverListener={!rowTooltipText && !primarySuperscripts.includes('c')}>
                      <TableCell
                        style={rowGreyedOut ? { backgroundColor: '#e0e0e0', color: 'black', opacity: 0.7 } : {}}
                        align="left"
                        className={classes.colHeader}
                      >{`${props.Win_Rate_Prefix} (from ${props.lostStageFrom}) %`}
                      {!rowGreyedOut && renderSuperscripts(
                          primarySuperscripts.filter(s => s === 'c'),
                          "black"
                        )}
                      </TableCell>
                    </HtmlTooltip>
                    {segments.map((segment) => {
                      let rowData = props.tableData.filter(
                        (item) =>
                          item[props.primary] === industry &&
                          item[props.secondary] === segment
                      );
                      let winRatePercent =
                        rowData.length !== 0
                          ? rowData[0].winRatePercentage
                          : "";
                      let superscripts = rowData.length !== 0 ? rowData[0].superscripts : [];

                      const wrSegHighlight = getSegmentHighlight(
                        props.highlightData, props.primary, industry,
                        'maxWinRateSegments', 'minWinRateSegments', segment
                      );
                      // Need to know if this is the min cell specifically (for the 'c' grey override)
                      const isMinWinRateCell = props.highlightData
                        ? props.highlightData.some(i =>
                            i[props.primary] === industry &&
                            Array.isArray(i.minWinRateSegments) && i.minWinRateSegments.includes(segment))
                        : false;

                      const columnGreyedOut = shouldGreyOutColumn(segment, industry);
                      const wonCellGreyedOut = shouldGreyOutWonCell(segment, industry);
                      const baseStyle = wrSegHighlight ? wrSegHighlight : {};

                      // Don't grey out min win rate cell (orange) even with superscript 'c'
                      // This ensures low performers with significant ACV pursued are highlighted as orange
                      const cellStyle = rowGreyedOut || columnGreyedOut
                        ? { ...baseStyle, backgroundColor: '#e0e0e0', color: 'black', opacity: 0.7 }
                        : (wonCellGreyedOut && !isMinWinRateCell)
                        ? { ...baseStyle, backgroundColor: '#e0e0e0', color: 'black', opacity: 0.7 }
                        : baseStyle;

                      let clr = cellStyle.color || 'black';

                      // When row greyed out, suppress cell superscripts
                      const cellSuperscriptsWR = rowGreyedOut ? [] : superscripts.filter(s => s === 'c');
                      const tooltipText = rowGreyedOut
                        ? rowTooltipText
                        : (props.cellAnnotations?.[`${industry}|||${segment}`]?.tooltips?.c || '');

                      return (
                        <HtmlTooltip key={segment} title={tooltipText || ''} disableHoverListener={!tooltipText}>
                          <TableCell
                            style={cellStyle}
                            align="right"
                            className={classes.colHeader}
                          >
                            {" "}
                            {![null, undefined, ""].includes(winRatePercent)
                              ? `${Math.round(winRatePercent * 100)}%`
                              : "-"}
                            {renderSuperscripts(
                              cellSuperscriptsWR,
                              clr
                            )}
                          </TableCell>
                        </HtmlTooltip>
                      );
                    })}
                    {(() => {
                      const wrColSuperscripts = !rowGreyedOut && primarySuperscripts.includes('c') ? ['c'] : [];
                      const isMinWinRatePrimary = Array.isArray(props.primaryHighlights?.minWinRatePrimaries)
                        && props.primaryHighlights.minWinRatePrimaries.includes(industry);
                      const wrColHighlight = getPrimaryHighlight(
                        props.primaryHighlights, 'maxWinRatePrimaries', 'minWinRatePrimaries', industry
                      );
                      let wrColStyle;
                      if (rowGreyedOut) {
                        wrColStyle = { backgroundColor: '#e0e0e0', color: 'black', opacity: 0.7 };
                      } else if (primarySuperscripts.includes('c') && !isMinWinRatePrimary) {
                        // Grey + 'c': fails opps threshold and not the lowest win rate primary
                        wrColStyle = { backgroundColor: '#e0e0e0', color: 'black', opacity: 0.7 };
                      } else {
                        // Normal: color from cross-primary comparison (or no color if no highlight)
                        // If 'c' AND isMinWinRatePrimary: wrColHighlight gives dark orange + 'c' is shown
                        wrColStyle = wrColHighlight || {};
                      }
                      const wrColTooltip = wrColSuperscripts.length > 0
                        ? (props.primaryDimensionAnnotations?.[industry]?.tooltips?.c || '')
                        : (rowTooltipText || '');
                      return (
                        <HtmlTooltip title={wrColTooltip || ''} disableHoverListener={!wrColTooltip}>
                          <TableCell
                            style={wrColStyle}
                            align="right"
                            className={classes.colHeader}
                          >
                            {![null, undefined, ""].includes(totalwinRate)
                              ? `${Math.round(totalwinRate * 100)}%`
                              : "-"}
                            {renderSuperscripts(wrColSuperscripts, wrColStyle.color || 'black')}
                          </TableCell>
                        </HtmlTooltip>
                      );
                    })()}
                  </StyledTableRow>

                  {/* Open Pipeline Row */}
                  <StyledTableRow>
                    <HtmlTooltip title={rowTooltipText || ''} disableHoverListener={!rowTooltipText}>
                      <TableCell
                        style={rowGreyedOut ? { backgroundColor: '#e0e0e0', color: 'black', opacity: 0.7 } : {}}
                        align="left"
                        className={classes.colHeader}
                      >{`Open Pipeline (${props.lostStageFrom} or later)`}</TableCell>
                    </HtmlTooltip>
                    {segments.map((segment) => {
                      let rowData = props.tableData.filter(
                        (item) =>
                          item[props.primary] === industry &&
                          item[props.secondary] === segment
                      );
                      let pipelineAcv =
                        rowData.length !== 0 ? rowData[0].pipelineAcv : "";
                      let superscripts = rowData.length !== 0 ? rowData[0].superscripts : [];
                      
                      const pipeSegHighlight = getSegmentHighlight(
                        props.highlightData, props.primary, industry,
                        'maxPipelineSegments', 'minPipelineSegments', segment
                      );
                      const columnGreyedOut = shouldGreyOutColumn(segment, industry);
                      const baseStyle = pipeSegHighlight
                        ? { ...pipeSegHighlight, cursor: 'pointer' }
                        : { cursor: 'pointer' };

                      const cellStyle = rowGreyedOut || columnGreyedOut
                        ? { ...baseStyle, backgroundColor: '#e0e0e0', color: 'black', opacity: 0.7 }
                        : baseStyle;

                      const cellSuperscriptsPipeline = rowGreyedOut ? [] : superscripts.filter(s => s === 'b');
                      const tooltipText = rowGreyedOut
                        ? rowTooltipText
                        : (props.cellAnnotations?.[`${industry}|||${segment}`]?.tooltips?.b || '');

                      return (
                        <HtmlTooltip key={segment} title={tooltipText || ''} disableHoverListener={!tooltipText}>
                          <TableCell
                            style={cellStyle}
                            onClick={() =>
                              props.handleChangeLocation(
                                "drilldownOnGraph",
                                { industry: [industry], segment: [segment] },
                                "Open",
                                props.type
                              )
                            }
                            align="right"
                            className={classes.colHeader}
                          >
                            {![null, undefined, "", 0, "0"].includes(pipelineAcv)
                              ? countOrACVFormatter(pipelineAcv, true)
                              : "-"}
                          </TableCell>
                        </HtmlTooltip>
                      );
                    })}
                    {(() => {
                      const pipeColHighlight = getPrimaryHighlight(
                        props.primaryHighlights, 'maxPipelinePrimaries', 'minPipelinePrimaries', industry
                      );
                      const pipeColStyle = rowGreyedOut
                        ? { backgroundColor: '#e0e0e0', color: 'black', opacity: 0.7, cursor: 'pointer' }
                        : pipeColHighlight
                        ? { ...pipeColHighlight, cursor: 'pointer' }
                        : { cursor: 'pointer' };
                      return (
                        <HtmlTooltip title={rowTooltipText || ''} disableHoverListener={!rowTooltipText}>
                          <TableCell
                            onClick={() =>
                              props.handleChangeLocation(
                                "drilldownOnGraph",
                                { industry: [industry], segment: segments },
                                "Open",
                                props.type
                              )
                            }
                            align="right"
                            style={pipeColStyle}
                            className={classes.colHeader}
                          >
                            {![null, undefined, "", 0, "0"].includes(totalpipelineAcv)
                              ? countOrACVFormatter(totalpipelineAcv, true)
                              : "-"}
                          </TableCell>
                        </HtmlTooltip>
                      );
                    })()}
                  </StyledTableRow>

                  {/* Insights Row - always rendered for visual grouping separation */}
                  <StyledTableRow>
                    <TableCell colSpan={segments.length + 2} style={{ paddingTop: '1.5rem', paddingBottom: '0.5rem', paddingLeft: '10px', paddingRight: '10px' }}>
                      {!rowGreyedOut && props.insights[`${props.primary}.${industry}`] && (
                        <DashboardInsights data={props.insights[`${props.primary}.${industry}`]} />
                      )}
                    </TableCell>
                  </StyledTableRow>
                </React.Fragment>
              );
            })}

            {/* GRAND TOTAL SECTION */}
            {props.wonRowData.length >= 1 && (
              <React.Fragment>
                {/* Total (ACV Pursued) Row */}
                <StyledTableRow>
                  <TableCell
                    style={{ background: "#5b9bd5", color: "white" }}
                    align="left"
                    className={classes.colHeader}
                  >
                    {"Total"} ({`${props.Value_Label}`} Pursued)
                  </TableCell>
                  {segments.map((segment) => {
                    let rowData = props.wonRowData.filter(
                      (item) => item[props.secondary] === segment
                    );
                    let pursued =
                      rowData.length !== 0 ? rowData[0].acvPursued : "";
                    let pursuedCount =
                      rowData.length !== 0 ? rowData[0].countPursued : "";
                    let superscripts = rowData.length !== 0 ? rowData[0].superscripts : [];
                    
                    const shouldGreyOut = superscripts.includes('a') || superscripts.includes('b');
                    
                    const gtAcvSegHighlight = getSegmentHighlight(
                      props.highlightData, props.primary, 'Won',
                      'maxAcvPursuedSegments', 'minACVPursuedSegments', segment
                    );
                    const baseStyle = gtAcvSegHighlight
                      ? { ...gtAcvSegHighlight, cursor: 'pointer' }
                      : { background: "#5b9bd5", color: "white", cursor: 'pointer' };

                    const cellStyle = shouldGreyOut
                      ? { ...baseStyle, backgroundColor: '#e0e0e0', color: 'black', opacity: 0.7 }
                      : baseStyle;

                    const tooltipText = props.grandTotalAnnotations?.[segment]?.tooltips?.a
                      || props.grandTotalAnnotations?.[segment]?.tooltips?.b
                      || '';

                    return (
                      <HtmlTooltip key={segment} title={tooltipText || ''} disableHoverListener={!tooltipText}>
                        <TableCell
                          style={cellStyle}
                          onClick={() =>
                            props.handleChangeLocation(
                              "drilldownOnGraph",
                              { industry: industries, segment: [segment] },
                              "Pursued",
                              props.type
                            )
                          }
                          align="right"
                          className={classes.colHeader}
                        >
                          <span>
                            {![null, undefined, "", 0, "0"].includes(pursued)
                              ? countOrACVFormatter(pursued, true)
                              : "-"}
                          </span>
                          <span align="right" style={{ marginLeft: "1rem" }}>{`(${
                            ![null, undefined, "", 0, "0"].includes(pursuedCount)
                              ? countOrACVFormatter(pursuedCount, false)
                              : "-"
                          })`}</span>
                          {renderSuperscripts(
                            superscripts.filter(s => s === 'a' || s === 'b'),
                            cellStyle.color || 'white'
                          )}
                        </TableCell>
                      </HtmlTooltip>
                    );
                  })}
                  <TableCell
                    style={{ background: "#5b9bd5", color: "white", cursor: 'pointer' }}
                    align="right"
                    className={classes.colHeader}
                    onClick={() =>
                      props.handleChangeLocation(
                        "drilldownOnGraph",
                        { industry: industries, segment: segments },
                        "Pursued",
                        props.type
                      )
                    }
                  >
                    <span>
                      {![null, undefined, "", 0, "0"].includes(
                        props.grandTotalData.acvPursued
                      )
                        ? countOrACVFormatter(
                            props.grandTotalData.acvPursued,
                            true
                          )
                        : "-"}
                    </span>
                    <span align="right" style={{ marginLeft: "1rem" }}>{`(${
                      ![null, undefined, "", 0, "0"].includes(
                        props.grandTotalData.countPursued
                      )
                        ? countOrACVFormatter(
                            props.grandTotalData.countPursued,
                            false
                          )
                        : "-"
                    })`}</span>
                  </TableCell>
                </StyledTableRow>
                
                {/* Lost or Disqualified Row */}
                <StyledTableRow>
                  <TableCell
                    align="left"
                    className={classes.colHeader}
                  >{`Lost or Disqualified (${props.lostStageFrom} or later)`}</TableCell>
                  {segments.map((segment) => {
                    let rowData = props.wonRowData.filter(
                      (item) => item[props.secondary] === segment
                    );
                    let lost = rowData.length !== 0 ? rowData[0].lostAcv : "";
                    let lostCount =
                      rowData.length !== 0 ? rowData[0].lostCount : "";
                    
                    const columnGreyedOut = shouldGreyOutGrandTotalColumn(segment);
                    const cellStyle = columnGreyedOut
                      ? { backgroundColor: '#e0e0e0', color: 'black', opacity: 0.7, cursor: "pointer" }
                      : { cursor: "pointer" };

                    return (
                      <TableCell
                        key={segment}
                        onClick={() =>
                          props.handleChangeLocation(
                            "drilldownOnGraph",
                            { industry: industries, segment: [segment] },
                            "Lost",
                            props.type
                          )
                        }
                        style={cellStyle}
                        align="right"
                        className={classes.colHeader}
                      >
                        <span>
                          {![null, undefined, "", 0, "0"].includes(lost)
                            ? countOrACVFormatter(lost, true)
                            : "-"}
                        </span>
                        <span align="right" style={{ marginLeft: "1rem" }}>{`(${
                          ![null, undefined, "", 0, "0"].includes(lostCount)
                            ? countOrACVFormatter(lostCount, false)
                            : "-"
                        })`}</span>
                      </TableCell>
                    );
                  })}
                  <TableCell
                    onClick={() =>
                      props.handleChangeLocation(
                        "drilldownOnGraph",
                        { industry: industries, segment: segments },
                        "Lost",
                        props.type
                      )
                    }
                    style={{ cursor: "pointer" }}
                    align="right"
                    className={classes.colHeader}
                  >
                    <span>
                      {![null, undefined, "", 0, "0"].includes(
                        props.grandTotalData.lostAcv
                      )
                        ? countOrACVFormatter(
                            props.grandTotalData.lostAcv,
                            true
                          )
                        : "-"}
                    </span>
                    <span align="right" style={{ marginLeft: "1rem" }}>{`(${
                      ![null, undefined, "", 0, "0"].includes(
                        props.grandTotalData.lostCount
                      )
                        ? countOrACVFormatter(
                            props.grandTotalData.lostCount,
                            false
                          )
                        : "-"
                    })`}</span>
                  </TableCell>
                </StyledTableRow>
                
                {/* Won Row */}
                <StyledTableRow>
                  <TableCell align="left" className={classes.colHeader}>
                    Won
                  </TableCell>
                  {segments.map((segment) => {
                    let rowData = props.wonRowData.filter(
                      (item) => item[props.secondary] === segment
                    );
                    let won = rowData.length !== 0 ? rowData[0].acv : "";
                    let count = rowData.length !== 0 ? rowData[0].count : "";
                    let superscripts = rowData.length !== 0 ? rowData[0].superscripts : [];
                    
                    const columnGreyedOut = shouldGreyOutGrandTotalColumn(segment);
                    const wonCellGreyedOut = shouldGreyOutGrandTotalWonCell(segment);

                    // Check if this is the min win rate cell in Grand Total
                    const isMinWinRateCellGTWon = props.highlightData ? props.highlightData.filter(
                      (i) => i[props.primary] === "Won" && Array.isArray(i.minWinRateSegments) && i.minWinRateSegments.includes(segment)
                    ).length >= 1 : false;

                    const cellStyle = columnGreyedOut || wonCellGreyedOut
                      ? { backgroundColor: '#e0e0e0', color: 'black', opacity: 0.7, cursor: "pointer" }
                      : { cursor: "pointer" };

                    const tooltipText = props.grandTotalAnnotations?.[segment]?.tooltips?.c || '';

                    return (
                      <HtmlTooltip key={segment} title={tooltipText || ''} disableHoverListener={!tooltipText}>
                        <TableCell
                          onClick={() =>
                            props.handleChangeLocation(
                              "drilldownOnGraph",
                              { industry: industries, segment: [segment] },
                              "Won",
                              props.type
                            )
                          }
                          style={cellStyle}
                          align="right"
                          className={classes.colHeader}
                        >
                          <span>
                            {![null, undefined, "", 0, "0"].includes(won)
                              ? countOrACVFormatter(won, true)
                              : "-"}
                          </span>
                          <span align="right" style={{ marginLeft: "1rem" }}>{`(${
                            ![null, undefined, "", 0, "0"].includes(count)
                              ? countOrACVFormatter(count, false)
                              : "-"
                          })`}</span>
                          {renderSuperscripts(
                            superscripts.filter(s => s === 'c'),
                            cellStyle.color || 'black'
                          )}
                        </TableCell>
                      </HtmlTooltip>
                    );
                  })}
                  {(() => {
                    const gtCornerSuperscripts = (props.grandTotalData.superscripts || []).filter(s => s === 'c');
                    const gtCornerStyle = gtCornerSuperscripts.length > 0
                      ? { backgroundColor: '#e0e0e0', color: 'black', opacity: 0.7, cursor: 'pointer' }
                      : { cursor: 'pointer' };
                    const gtCornerTooltip = props.grandTotalCornerAnnotation?.tooltips?.c || '';
                    return (
                      <HtmlTooltip title={gtCornerTooltip || ''} disableHoverListener={!gtCornerTooltip}>
                        <TableCell
                          onClick={() =>
                            props.handleChangeLocation(
                              "drilldownOnGraph",
                              { industry: industries, segment: segments },
                              "Won",
                              props.type
                            )
                          }
                          style={gtCornerStyle}
                          align="right"
                          className={classes.colHeader}
                        >
                          <span>
                            {![null, undefined, "", 0, "0"].includes(props.grandTotalData.acv)
                              ? countOrACVFormatter(props.grandTotalData.acv, true)
                              : "-"}
                          </span>
                          <span align="right" style={{ marginLeft: "1rem" }}>{`(${
                            ![null, undefined, "", 0, "0"].includes(props.grandTotalData.count)
                              ? countOrACVFormatter(props.grandTotalData.count, false)
                              : "-"
                          })`}</span>
                          {renderSuperscripts(gtCornerSuperscripts, gtCornerStyle.color || 'black')}
                        </TableCell>
                      </HtmlTooltip>
                    );
                  })()}
                </StyledTableRow>
                
                {/* Won % of Total Row */}
                <StyledTableRow>
                  <TableCell align="left" className={classes.colHeader}>
                    Won % of Total
                  </TableCell>
                  {segments.map((segment) => {
                    let rowData = props.wonRowData.filter(
                      (item) => item[props.secondary] === segment
                    );
                    let wonPercentage =
                      rowData.length !== 0 ? rowData[0].wonTotalPercentage : "";
                    
                    const columnGreyedOut = shouldGreyOutGrandTotalColumn(segment);
                    const cellStyle = columnGreyedOut
                      ? { backgroundColor: '#e0e0e0', color: 'black', opacity: 0.7 }
                      : {};

                    return (
                      <TableCell key={segment} style={cellStyle} align="right" className={classes.colHeader}>
                        {" "}
                        {![null, undefined, ""].includes(wonPercentage)
                          ? `${Math.round(wonPercentage * 100)}%`
                          : "-"}
                      </TableCell>
                    );
                  })}
                  <TableCell align="right" className={classes.colHeader}>
                    100%
                  </TableCell>
                </StyledTableRow>
                
                {/* Avg / Median Cycle Time Row */}
                <StyledTableRow>
                  <TableCell
                    align="left"
                    className={classes.colHeader}
                  >{`Avg. / Median Cycle Time  (${props.lostStageFrom} to Won)`}</TableCell>
                  {segments.map((segment) => {
                    let rowData = props.wonRowData.filter(
                      (item) => item[props.secondary] === segment
                    );
                    let averageCycleTime =
                      rowData.length !== 0 ? rowData[0].avgCycleTime : "";
                    let medianCycleTime =
                      rowData.length !== 0 ? rowData[0].medianCycleTime : "";
                    
                    const columnGreyedOut = shouldGreyOutGrandTotalColumn(segment);
                    const cellStyle = columnGreyedOut
                      ? { backgroundColor: '#e0e0e0', color: 'black', opacity: 0.7 }
                      : {};

                    return (
                      <TableCell key={segment} style={cellStyle} align="right" className={classes.colHeader}>
                        <span>
                          {![null, undefined, "", 0, "0"].includes(
                            averageCycleTime
                          )
                            ? countOrACVFormatter(averageCycleTime, false)
                            : "-"}
                        </span>
                        <span style={{ margin: "0.25rem" }}>/</span>
                        <span>{`${
                          ![null, undefined, "", 0, "0"].includes(
                            medianCycleTime
                          )
                            ? countOrACVFormatter(medianCycleTime, false)
                            : "-"
                        }`}</span>
                      </TableCell>
                    );
                  })}
                  <TableCell align="right" className={classes.colHeader}>
                    <span>
                      {![null, undefined, "", 0, "0"].includes(
                        props.grandTotalData.avgCycleTime
                      )
                        ? countOrACVFormatter(
                            props.grandTotalData.avgCycleTime,
                            false
                          )
                        : "-"}
                    </span>
                    <span style={{ margin: "0.25rem" }}>/</span>
                    <span>{`${
                      ![null, undefined, "", 0, "0"].includes(
                        props.grandTotalData.medianCycleTime
                      )
                        ? countOrACVFormatter(
                            props.grandTotalData.medianCycleTime,
                            false
                          )
                        : "-"
                    }`}</span>
                  </TableCell>
                </StyledTableRow>
                
                {/* Win Rate Row */}
                <StyledTableRow>
                  <TableCell
                    align="left"
                    className={classes.colHeader}
                  >{`${props.Win_Rate_Prefix} (from ${props.lostStageFrom}) %`}</TableCell>
                  {segments.map((segment) => {
                    let rowData = props.wonRowData.filter(
                      (item) => item[props.secondary] === segment
                    );
                    let winRatePercent =
                      rowData.length !== 0 ? rowData[0].winRatePercentage : "";
                    let superscripts = rowData.length !== 0 ? rowData[0].superscripts : [];
                    
                    const columnGreyedOut = shouldGreyOutGrandTotalColumn(segment);
                    const wonCellGreyedOut = shouldGreyOutGrandTotalWonCell(segment);

                    const gtWrSegHighlight = getSegmentHighlight(
                      props.highlightData, props.primary, 'Won',
                      'maxWinRateSegments', 'minWinRateSegments', segment
                    );
                    const isMinWinRateCellGT = props.highlightData
                      ? props.highlightData.some(i =>
                          i[props.primary] === 'Won' &&
                          Array.isArray(i.minWinRateSegments) && i.minWinRateSegments.includes(segment))
                      : false;
                    const baseStyle = gtWrSegHighlight ? gtWrSegHighlight : {};

                    // Don't grey out min win rate cell (orange) even with superscript 'c'
                    const cellStyle = columnGreyedOut
                      ? { ...baseStyle, backgroundColor: '#e0e0e0', color: 'black', opacity: 0.7 }
                      : (wonCellGreyedOut && !isMinWinRateCellGT)
                      ? { ...baseStyle, backgroundColor: '#e0e0e0', color: 'black', opacity: 0.7 }
                      : baseStyle;

                    let clr = cellStyle.color || 'black';
                    const tooltipText = props.grandTotalAnnotations?.[segment]?.tooltips?.c || '';

                    return (
                      <HtmlTooltip key={segment} title={tooltipText || ''} disableHoverListener={!tooltipText}>
                        <TableCell
                          style={cellStyle}
                          align="right"
                          className={classes.colHeader}
                        >
                          {" "}
                          {![null, undefined, ""].includes(winRatePercent)
                            ? `${Math.round(winRatePercent * 100)}%`
                            : "-"}
                          {renderSuperscripts(
                            superscripts.filter(s => s === 'c'),
                            clr
                          )}
                        </TableCell>
                      </HtmlTooltip>
                    );
                  })}
                  {(() => {
                    const gtWrCornerSuperscripts = (props.grandTotalData.superscripts || []).filter(s => s === 'c');
                    const gtWrCornerStyle = gtWrCornerSuperscripts.length > 0
                      ? { backgroundColor: '#e0e0e0', color: 'black', opacity: 0.7 }
                      : {};
                    const gtWrCornerTooltip = props.grandTotalCornerAnnotation?.tooltips?.c || '';
                    return (
                      <HtmlTooltip title={gtWrCornerTooltip || ''} disableHoverListener={!gtWrCornerTooltip}>
                        <TableCell style={gtWrCornerStyle} align="right" className={classes.colHeader}>
                          {![null, undefined, ""].includes(props.grandTotalData.winRatePercentage)
                            ? `${Math.round(props.grandTotalData.winRatePercentage * 100)}%`
                            : "-"}
                          {renderSuperscripts(gtWrCornerSuperscripts, gtWrCornerStyle.color || 'black')}
                        </TableCell>
                      </HtmlTooltip>
                    );
                  })()}
                </StyledTableRow>

                {/* Open Pipeline Row */}
                <StyledTableRow>
                  <TableCell
                    align="left"
                    className={classes.colHeader}
                  >{`Open Pipeline (${props.lostStageFrom} or later)`}</TableCell>
                  {segments.map((segment) => {
                    let rowData = props.wonRowData.filter(
                      (item) => item[props.secondary] === segment
                    );
                    let pipelineAcv =
                      rowData.length !== 0 ? rowData[0].pipelineAcv : "";
                    
                    const columnGreyedOut = shouldGreyOutGrandTotalColumn(segment);
                    
                    const gtPipeSegHighlight = getSegmentHighlight(
                      props.highlightData, props.primary, 'Won',
                      'maxPipelineSegments', 'minPipelineSegments', segment
                    );
                    const baseStyle = gtPipeSegHighlight
                      ? { ...gtPipeSegHighlight, cursor: 'pointer' }
                      : { cursor: 'pointer' };

                    const cellStyle = columnGreyedOut
                      ? { ...baseStyle, backgroundColor: '#e0e0e0', color: 'black', opacity: 0.7 }
                      : baseStyle;

                    return (
                      <TableCell
                        key={segment}
                        onClick={() =>
                          props.handleChangeLocation(
                            "drilldownOnGraph",
                            { industry: industries, segment: [segment] },
                            "Open",
                            props.type
                          )
                        }
                        style={cellStyle}
                        align="right"
                        className={classes.colHeader}
                      >
                        {![null, undefined, "", 0, "0"].includes(pipelineAcv)
                          ? countOrACVFormatter(pipelineAcv, true)
                          : "-"}
                      </TableCell>
                    );
                  })}
                  <TableCell
                    onClick={() =>
                      props.handleChangeLocation(
                        "drilldownOnGraph",
                        { industry: industries, segment: segments },
                        "Open",
                        props.type
                      )
                    }
                    style={{ cursor: "pointer" }}
                    align="right"
                    className={classes.colHeader}
                  >
                    {![null, undefined, "", 0, "0"].includes(
                      props.grandTotalData.pipelineAcv
                    )
                      ? countOrACVFormatter(
                          props.grandTotalData.pipelineAcv,
                          true
                        )
                      : "-"}
                  </TableCell>
                </StyledTableRow>
                <StyledTableRow>
                    {
                      props.totalInsights && 
                      <TableCell colSpan={segments.length + 2} style={{ paddingTop: '1.5rem', paddingBottom: '0.5rem', paddingLeft: '10px', paddingRight: '10px', borderBottom: 'none' }}>
                      <DashboardInsights data={props.totalInsights.Total} />
                    </TableCell>
                    }
                  </StyledTableRow>
              </React.Fragment>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}